import { createReducer } from '@reduxjs/toolkit'
import { preloadedRootState } from '../../rootState'
import { setDictionary, setDictionaryReducer } from './setDictionaryReducer'

const userReducers = createReducer(preloadedRootState.dictionary, builder => {
  builder.addCase(setDictionary.type, setDictionaryReducer)
})

export default userReducers
